<template>
    <div class="DshCascaderMultiple ycFormItem">
        <Cascader
            class="DshCascaderMultiple-control"
            v-model="cascaderVal"
            :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}` : ''"
            :data="renderCascaderData"
            :load-data="loadData"
            :change-on-select="propsObj._changeOnSelect"
            :filterable="true"
            :disabled="!finalCanEdit"
            :clearable="clearable"
            :transfer="true"
        ></Cascader>
        <dsh-buttons
            class="DshCascaderMultiple-create"
            :list="$getOperationList(['createTag'])"
            @click="$dispatchEvent($event)"
        ></dsh-buttons>

        <!-- 标签列表 -->
        <dsh-tags
            class="dsh-margin-top5"
            :list="tags"
            @delete="$dispatchEvent(operationMap.deleteTag, arguments)"
        ></dsh-tags>
    </div>
</template>

<script>
    import { regionData } from "../../../datas/index.js";
    import controlMixin from "../controlMixin.js";

    const loop = function (data = [], level, parentCode, filterVals = []) {
        if (data && filterVals.length) {
            data = data.filter(item => filterVals.includes(item._key));
        }
        return data
            ? data.reduce((arr, item) => {
                const newItem = {
                    ...item,
                    value: item._key,
                    label: item.name,
                    codeArr: [ ...(parentCode || []), item._key ]
                };
                if (!level || level > item.level) {
                    newItem.children = loop(item.children, level, newItem.codeArr);
                    newItem.children.length && (newItem.loading = false); // 此代码为了所请求的级出现继续加载的箭头图标
                } else {
                    newItem.children = [];
                }
                arr.push(newItem);

                return arr;
            }, [])
            : [];
    };

    export default {
        name: "DshCascaderMultiple",
        mixins: [controlMixin],
        props: {},
        data () {
            return {
                cascaderVal: [],

                operationMap: {
                    createTag: {
                        name: "添加",
                        type: "createTag",
                        size: "default",
                        event: "createTag"
                    },
                    deleteTag: {
                        name: "删除",
                        type: "deleteTag",
                        event: "deleteTag"
                    }
                }
            };
        },
        computed: {
            cascaderData: {
                get () {
                    return loop(
                        this.propsObj._subType === "region" ? regionData : this.propsObj._data,
                        this.propsObj._cascaderLevel,
                        undefined,
                        this.propsObj._cascaderFilterVals
                    );
                },
                set () {}
            },
            renderCascaderData () {
                return this.cascaderData.map(item => {
                    return {
                        ...item,
                        children: []
                    };
                });
            },
            tags () {
                return this.value[this.propsObj._key].map(item => this.$getTreeLinealDatas(item, this.cascaderData, "name").join("/"));
            }
        },
        created () {},
        methods: {
            // 动态加载数据
            loadData (treeItem, cb) {
                let list = this.$getTreeLinealDatas(treeItem.codeArr, this.cascaderData);
                treeItem.children = list[list.length - 1].children.map(item => ({ ...item, children: [] }));

                cb();
            },

            // 添加
            createTag (operationItem) {
                if (this.cascaderVal.length) {
                    if (this.value[this.propsObj._key].some(item => JSON.stringify(item) == JSON.stringify(this.cascaderVal))) {
                        this.$Message.error({
                            content: `"${this.$getTreeLinealDatas(this.cascaderVal, this.cascaderData, "name").join("/")}"已选择，请勿重复选择！`,
                            duration: 5
                        });
                    } else {
                        this.value[this.propsObj._key].push([...this.cascaderVal]);
                        this.change();
                    }

                }
                this.cascaderVal = [];
            },
            // 删除
            deleteTag (operationItem, params) {
                this.value[this.propsObj._key].splice(params[1], 1);
                this.change();
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshCascaderMultiple {
        width: 100%;
        &-control {
            display: inline-block;
            width: calc(100% - 65px);
        }
        &-create {
            display: inline-block;
            width: 60px;
        }
    }
</style>
<style lang="less">
    .DshCascaderMultiple {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshCascaderMultiple.vue